<template>
  <AppDialog v-model:is-open="isDialogOpened"
             size="l"
             ok-only
             :ok-text="$t('common.share')"
             :ok-disabled="getArchiveRightsPending"
             :ok-loading="shareArchivesPending"
             @cancel="closeDialog"
             @ok="share"
  >
    <template #title>{{ $t('archives.dialogs.ArchivesShareDialog.title') }}</template>

    <template #subTitle>
      <span v-t="{
              path: 'archives.dialogs.ArchivesShareDialog.subtitle',
              plural: selectedDocuments.length - 1,
              args: { name: selectedDocuments[0].docName },
            }"
      />
    </template>

    <template #body>
      <ArchivesShareModule
        v-if="!getArchiveRightsPending"
        v-model:value="shareConfig"
      />
      <div v-else class="text-center">
        <v-progress-circular
          style="width: 64px; height: 64px"
          color="primary"
          indeterminate
          size="64"
        />
      </div>
    </template>
  </AppDialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { ArchivesActionTypes } from '@/store/modules/archives/action_types'

import ArchivesShareModule from '../ArchivesShareModule.vue'

const { mapActions, mapState } = createNamespacedHelpers('archives')

export default {
  name: 'ArchivesShareDialog',
  components: { AppDialog, ArchivesShareModule },
  mixins: [dialogMixin],
  props: {},
  data () {
    return {
      shareConfig: {
        fileRights: [],
        notifyMessage: '',
        notify: false,
      },
    }
  },
  computed: {
    ...mapState(['getArchiveRightsPending', 'currentArchiveRights', 'shareArchivesPending', 'selectedDocuments']),
  },
  async created () {
    // If there is only one archive to share, we will get its initial config
    if (this.selectedDocuments.length === 1) {
      await this.GET_ARCHIVE_RIGHTS(this.selectedDocuments[0].id)
      this.shareConfig.fileRights = this.currentArchiveRights.read.users.map((u) => u.id)
    }
  },
  methods: {
    ...mapActions([ArchivesActionTypes.GET_ARCHIVE_RIGHTS, ArchivesActionTypes.SHARE_ARCHIVES]),
    async share () {
      const formData = new FormData()
      formData.append('withUsers', this.shareConfig.fileRights)
      formData.append('notify', this.shareConfig.notify)
      formData.append('notifyMessage', this.shareConfig.notifyMessage)
      formData.append('archives', this.selectedDocuments.map((a) => a.id))
      await this.SHARE_ARCHIVES(formData)
      toast.success(this.$t('archives.dialogs.ArchivesShareDialog.success', this.selectedDocuments.length))
      this.closeDialog()
    },
  },
}
</script>
